if (!customElements.get('shop-the-look-slider')) {
  class ShopTheLookSlider extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      this.dotsList = this.querySelector('.js-dots-list');
      this.pagination = this.querySelector('.shop-the-look--pagination');
      this.nextArrow = this.querySelector('.shop-the-look--next');
      this.prevArrow = this.querySelector('.shop-the-look--prev');

      this.sliderOptions.breakpoints = {
        750: {
          slidesPerView: 1,
          spaceBetween: 72
        },
        990: {
          spaceBetween: 100
        },
        1100: {
          spaceBetween: 130
        },
        1200: {
          spaceBetween: 156
        }
      };

      this.sliderOptions.navigation = {
        prevEl: this.prevArrow,
        nextEl: this.nextArrow,
      }

      if (this.pagination) {
        this.sliderOptions.pagination = {
          el: this.pagination,
          type: 'progressbar'
        }
      }

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
          this.initSlider(this.querySelector('.js-slider'));
        });
      }

      this.initSlider(this.querySelector('.js-slider'));

      this.dotsList?.addEventListener('click', e => {
        const isBtn = e.target.classList.contains('js-btn');

        if (!isBtn) {
          return;
        }

        e.preventDefault();

        const btn = e.target;
        const isCurrent = btn.classList.contains('is-current');

        if (isCurrent) {
          return;
        }

        const btnIndex = +btn.dataset.index;

        this.updateActiveDot(btn);
        this.slider.slideTo(btnIndex, 300);
      });

      this.slider?.on('slideChange', e => {
        const sliderIndex = e.realIndex;
        const btn = this.dotsList?.querySelector(
          `.js-btn[data-index="${sliderIndex}"]`
        );

        this.updateActiveDot(btn);
      });
      this.initDrawer();
    }

    connectedCallback() {}

    updateActiveDot(btn) {
      const currentBtn = this.dotsList?.querySelector(
        '.js-btn.is-current'
      );

      currentBtn.classList.remove('is-current');
      currentBtn.setAttribute('aria-current', false);

      btn.classList.add('is-current');
      btn.setAttribute('aria-current', true);
    }

    initDrawer() {
      const drawer = document.querySelector(
        ".shop-the-look-drawer__blocks"
      );
      const drawerContainer = document.querySelector(
        "shop-the-look-drawer"
      );
      if (!drawer || !drawerContainer) return;
    }
  }

  customElements.define('shop-the-look-slider', ShopTheLookSlider);
}

function initShopTheLookFullBanner() {
  const banners = document.querySelectorAll('.shop-the-look__full-banner:not([data-full-banner-inited])');
  banners.forEach(function(banner) {
    const dots = banner.querySelectorAll('.shop-the-look__full-banner-dots ul li');
    const triggers = banner.querySelectorAll('.shop-the-look__full-banner-dot-trigger');
    const instanceRoot = banner.closest('.shop-the-look__instance') || banner.parentElement;
    const dotsContainer = banner.querySelector('.shop-the-look__full-banner-dots');
    let mobileBottom = banner.nextElementSibling;
    if (!mobileBottom || !mobileBottom.classList.contains('shop-the-look__full-banner-mobile-bottom')) {
      mobileBottom = instanceRoot
        ? instanceRoot.querySelector('.shop-the-look__full-banner-mobile-bottom')
        : null;
    }
    if (!dots.length || !triggers.length) return;

    banner.setAttribute('data-full-banner-inited', 'true');

    var suppressDotSyncFromScroll = false;
    const mqDesktop = window.matchMedia('(min-width: 990px)');

    function updateActiveCardPosition(li, forceMeasure = false) {
      if (!li || !dotsContainer) return;
      const card = li.querySelector('.shop-the-look__item-card');
      if (!card) return;

      // Reset class so we can measure natural position first.
      li.classList.remove('shop-the-look__full-banner-dot-li--edge-inline-end');
      li.classList.remove('shop-the-look__full-banner-dot-li--edge-block-end-card');

      // Only relevant on desktop. By default we measure only active dots,
      // but we can force a pre-measure on page load / resize.
      if (!mqDesktop.matches) return;
      if (!forceMeasure && !li.classList.contains('is-active')) return;

      const containerRect = dotsContainer.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();

      if (cardRect.right > containerRect.right || cardRect.left < containerRect.left) {
        li.classList.add('shop-the-look__full-banner-dot-li--edge-inline-end');
      }

      if (cardRect.bottom > containerRect.bottom || cardRect.top < containerRect.top) {
        li.classList.add('shop-the-look__full-banner-dot-li--edge-block-end-card');
      }
    }

    function precomputeDotCardPositions() {
      if (!mqDesktop.matches) return;
      dots.forEach(function(li) {
        updateActiveCardPosition(li, true);
      });
    }

    function setDotActiveState(li) {
      dots.forEach(function(l) { l.classList.remove('is-active'); });
      if (li) li.classList.add('is-active');
    }

    function syncDotsFromMobileStripScroll() {
      if (suppressDotSyncFromScroll || !mobileBottom) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var cards = mobileBottom.querySelectorAll(
        '.shop-the-look__item-card--mobile-bottom'
      );
      if (!cards.length) return;

      var containerRect = mobileBottom.getBoundingClientRect();
      var centerX = containerRect.left + containerRect.width / 2;
      var bestLi = null;
      var bestDist = Infinity;

      cards.forEach(function(card) {
        var idxAttr = card.getAttribute('data-dot-index');
        if (idxAttr === null) return;
        var targetLi = banner.querySelector(
          'li.shop-the-look__full-banner-dot-li[data-dot-index="' + idxAttr + '"]'
        );
        if (!targetLi) return;
        var r = card.getBoundingClientRect();
        var cardCenter = r.left + r.width / 2;
        var dist = Math.abs(cardCenter - centerX);
        if (dist < bestDist) {
          bestDist = dist;
          bestLi = targetLi;
        }
      });

      if (!bestLi || bestLi.classList.contains('is-active')) return;
      setDotActiveState(bestLi);
    }

    var mobileBottomScrollRaf = null;
    function onMobileBottomScroll() {
      if (mobileBottomScrollRaf) cancelAnimationFrame(mobileBottomScrollRaf);
      mobileBottomScrollRaf = requestAnimationFrame(function() {
        mobileBottomScrollRaf = null;
        syncDotsFromMobileStripScroll();
      });
    }

    if (mobileBottom) {
      mobileBottom.addEventListener('scroll', onMobileBottomScroll, {
        passive: true
      });
    }

    function setActive(li) {
      setDotActiveState(li);
      if (mobileBottom) {
        mobileBottom.innerHTML = '';
        mobileBottom.setAttribute('aria-hidden', 'true');
        if (li) {
          const activeCard = li.querySelector('.shop-the-look__item-card');
          const orderedCards = [];
          if (activeCard) orderedCards.push(activeCard);
          dots.forEach(function(l) {
            const card = l.querySelector('.shop-the-look__item-card');
            if (card && card !== activeCard) orderedCards.push(card);
          });
          if (orderedCards.length) {
            suppressDotSyncFromScroll = true;
            orderedCards.forEach(function(card) {
              const clone = card.cloneNode(true);
              clone.classList.add('shop-the-look__item-card--mobile-bottom');
              var sourceLi = card.closest('li');
              if (sourceLi && sourceLi.hasAttribute('data-dot-index')) {
                clone.setAttribute(
                  'data-dot-index',
                  sourceLi.getAttribute('data-dot-index')
                );
              }
              mobileBottom.appendChild(clone);
            });
            mobileBottom.setAttribute('aria-hidden', 'false');
            requestAnimationFrame(function() {
              mobileBottom.scrollLeft = 0;
              requestAnimationFrame(function() {
                suppressDotSyncFromScroll = false;
                syncDotsFromMobileStripScroll();
              });
            });
          }
        }
      }

      // After state update, ensure the active card doesn't overflow.
      requestAnimationFrame(function() {
        updateActiveCardPosition(li);
      });
    }

    triggers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const li = btn.closest('li');
        const wasActive = li && li.classList.contains('is-active');
        setActive(wasActive ? null : li);
      });
    });

    // Keep a reference for the global outside-click handler.
    banner.__shopTheLookSetActive = setActive;
    banner.__shopTheLookUpdateCardPosition = updateActiveCardPosition;

    if (window.matchMedia('(max-width: 749px)').matches && dots[0]) {
      setActive(dots[0]);
    }

    // On initial load, precompute positions so dots are correct before click.
    requestAnimationFrame(function() {
      precomputeDotCardPositions();
      const activeLi = banner.querySelector('.shop-the-look__full-banner-dots ul li.is-active');
      if (activeLi) updateActiveCardPosition(activeLi);
    });
  });
}

function runInitShopTheLookFullBanner() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopTheLookFullBanner);
  } else {
    initShopTheLookFullBanner();
  }
}

runInitShopTheLookFullBanner();

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    initShopTheLookFullBanner();
  });
}

// Close any open full-banner popovers when clicking outside.
if (!window.__shopTheLookFullBannerOutsideClickBound) {
  window.__shopTheLookFullBannerOutsideClickBound = true;
  document.addEventListener('click', function(e) {
    // If the click is inside any full-banner, do not close other banners.
    if (e.target && e.target.closest && e.target.closest('.shop-the-look__full-banner')) {
      return;
    }
    document.querySelectorAll('.shop-the-look__full-banner[data-full-banner-inited="true"]').forEach((banner) => {
      if (banner.contains(e.target)) return;
      if (typeof banner.__shopTheLookSetActive === 'function') {
        banner.__shopTheLookSetActive(null);
      }
    });
  });
}

// Re-check card overflow on resize (desktop).
if (!window.__shopTheLookFullBannerResizeBound) {
  window.__shopTheLookFullBannerResizeBound = true;
  window.addEventListener('resize', () => {
    document.querySelectorAll('.shop-the-look__full-banner[data-full-banner-inited="true"]').forEach((banner) => {
      // Recompute for all dots to keep flips correct.
      const lis = banner.querySelectorAll('.shop-the-look__full-banner-dots ul li');
      const dotsContainer = banner.querySelector('.shop-the-look__full-banner-dots');
      if (dotsContainer && lis.length && typeof banner.__shopTheLookUpdateCardPosition === 'function') {
        lis.forEach((li) => banner.__shopTheLookUpdateCardPosition(li, true));
      }
      const activeLi = banner.querySelector('.shop-the-look__full-banner-dots ul li.is-active');
      if (!activeLi) return;
      if (typeof banner.__shopTheLookUpdateCardPosition === 'function') {
        banner.__shopTheLookUpdateCardPosition(activeLi);
      }
    });
  }, { passive: true });
}
